<template>
<div class="chapter">
<div class="inner_page">
<a id="piv"></a>
<p class="center ">Copyright © 2005 by Gerald Morris</p>
<div class="timebreak "> </div>
<p class="center ">All rights reserved. For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<div class="timebreak "> </div>
<p class="center ">
<a href="http://www.hmhco.com/popular-reading" target="_blank">hmhco.com</a>
</p>
<div class="timebreak "> </div>
<p class="center ">
<em>The Library of Congress has cataloged the print edition as follows:</em>
</p>
<p class="center ">Morris, Gerald, 1963–<br/>
The lioness and her knight / written by Gerald Morris.<br/>
p. cm.</p>
<p class="center ">Summary: Headstrong sixteen-year-old Lady Luneta and her distant cousin, Sir Ywain, travel to Camelot and beyond finding more adventure than they hoped for until, with the help of a fool, Luneta discovers what she really wants from life.</p>
<p class="center ">[1. Knights and knighthood—Fiction. 2. Adventure and adventurers—Fiction. 3. Self-actualization (Psychology)—Fiction. 4. Middle Ages—Fiction. 5. Great Britain—History—To 1066—Fiction. 6. Humorous stories.] I. Title.</p>
<p class="center ">PZ7.M82785Kn 2005 [Fic]—dc22 2004015782</p>
<div class="timebreak "> </div>
<p class="center ">ISBN 978-0-618-50772-6 hardcover</p>
<p class="center ">ISBN 978-0-547-01485-2 paperback</p>
<div class="timebreak "> </div>
<p class="center ">eISBN 978-0-547-53000-0<br/>
v3.0418</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?04d4d03f